import { hasRight } from 'nallian-shared-ui/lib/lib/routesHelper';

export const hasDocumentAccess = (
  rights,
  organisationId,
  principalOrganisationId,
  suffix = 'read'
) => {
  // Check for the basic required right: principals/documents/read
  if (!hasRight(rights, `principals/documents/${suffix}`)) {
    return false;
  }

  // If organisationId is not the same as the principalOrganisationId, check additional right
  // e.g. principals/documents/read/other-organisations
  if (organisationId !== principalOrganisationId) {
    if (!hasRight(rights, `principals/documents/${suffix}/other-organisations`)) {
      return false;
    }
  }

  // If all checks pass, return true
  return true;
};
